<template>
  <v-layout row wrap>
    <v-flex xs12>
      <v-layout row justify-center>
        <v-dialog v-model="dialog" persistent max-width="450">
          <v-card>
            <v-card-title class="headline">Delete selected approval user?</v-card-title>
            <v-card-text class="text-xs-left">You are going to delete this selected approval user.</v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="accent" flat @click="dialog = false">cancel</v-btn>
              <v-btn
                color="accent"
                flat
                @click="deleteApprovalUserById"
                :loading="getLoading"
                :disable="getLoading"
              >delete</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-layout>
    </v-flex>

    <v-flex xs12>
      <v-card>
        <v-card-title>
          <span class="title">Details</span>
        </v-card-title>
        <v-divider></v-divider>
        <v-card flat class="elevation-0">
          <v-card-title>
            <v-btn dark color="accent" to="/approver/new">new approver</v-btn>
            <v-spacer></v-spacer>
            <v-text-field
              append-icon="search"
              label="Search"
              single-line
              hide-details
              v-model="search"
            ></v-text-field>
          </v-card-title>
          <v-card-text>
            <v-data-table
              :loading="getLoading"
              v-bind:headers="headers"
              v-bind:items="getApprovalUsers"
              v-bind:search="search"
              v-model="selected"
              item-key="id"
              class="elevation-0"
              :rows-per-page-items="rowsPerPageItems"
            >
              <template slot="headerCell" slot-scope="props">
                <span>{{ props.header.text }}</span>
              </template>
              <template slot="items" slot-scope="props">
                <td class="text-xs-left">
                  <v-tooltip bottom v-if="props.item.is_blocked === 0">
                    <v-btn
                      flat
                      icon
                      @click="setUserStatus(props.item.id, props.item.is_blocked)"
                      color="red"
                      slot="activator"
                    >
                      <v-icon>block</v-icon>
                    </v-btn>
                    <span>Deactivate</span>
                  </v-tooltip>

                  <v-tooltip bottom v-if="props.item.is_blocked === 1">
                    <v-btn
                      flat
                      icon
                      @click="setUserStatus(props.item.id, props.item.is_blocked)"
                      color="primary"
                      slot="activator"
                    >
                      <v-icon>check_circle</v-icon>
                    </v-btn>
                    <span>Reactivate</span>
                  </v-tooltip>

                  <v-tooltip bottom>
                    <v-btn
                      flat
                      icon
                      @click="editApprovalUserById(props.item.id)"
                      color="accent lighten-1"
                      slot="activator"
                    >
                      <v-icon>edit</v-icon>
                    </v-btn>
                    <span>Change</span>
                  </v-tooltip>

                  <v-tooltip bottom>
                    <v-btn
                      flat
                      icon
                      @click="toggleDialog(props.item.id)"
                      color="error lighten-1"
                      slot="activator"
                    >
                      <v-icon>delete</v-icon>
                    </v-btn>
                    <span>Delete</span>
                  </v-tooltip>
                </td>
                <td class="text-xs-left">{{ props.item.employee_id}}</td>
                <!-- <td class="text-xs-left">{{ props.item.salutation}}</td> -->
                <td class="text-xs-left">{{ props.item.first_name}}</td>
                <td class="text-xs-left">{{ props.item.last_name}}</td>
                <!-- <td class="text-xs-left">{{ props.item.email}}</td> -->
                <td class="text-xs-left">{{ props.item.rank_description}}</td>
                <td class="text-xs-left">{{ props.item.is_blocked === 1 ? `Inactive` : `Activate`}}</td>
              </template>
            </v-data-table>
          </v-card-text>

          <v-snackbar :color="color" :timeout="timeout" bottom right v-model="snackbar">
            {{ text }}
            <v-btn flat dark @click.native="snackbar = false">
              <v-icon>clear</v-icon>
            </v-btn>
          </v-snackbar>
        </v-card>
      </v-card>
    </v-flex>
  </v-layout>
</template>


<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'approver-detail',
  data() {
    return {
      switch1: true,
      search: '',
      selected: [],
      selectedId: '',
      dialog: false,
      rowsPerPageItems: [10, 15, 20],
      headers: [
        {
          text: 'Actions',
          align: 'left',
          value: 'actions',
          sortable: false
        },
        {
          text: 'Employee ID',
          align: 'left',
          value: 'employee_id'
        },
        // {
        //   text: 'Salutation',
        //   align: 'left',
        //   value: 'salutation'
        // },
        {
          text: 'First name',
          align: 'left',
          value: 'first_name'
        },
        {
          text: 'Last name',
          align: 'left',
          value: 'last_name'
        },
        // {
        //   text: 'E-mail',
        //   align: 'left',
        //   value: 'email'
        // },
        {
          text: 'Release description',
          align: 'left',
          value: 'release_description'
        },
        {
          text: 'Status',
          align: 'left',
          value: 'status'
        }
      ],
      items: [],
      loader: null,
      snackbar: false,
      y: 'top',
      mode: '',
      timeout: 5000,
      text: '',
      color: ''
    }
  },
  methods: {
    ...mapActions([
      'fetchApprovalUsers',
      'deleteApprovalUser',
      'blockApprovalUser'
    ]),

    editApprovalUserById(id) {
      this.$router.push({ name: 'changeApprover', params: { id: id } })
    },

    toggleDialog: function(id) {
      this.selectedId = id
      this.dialog = true
    },

    deleteApprovalUserById() {
      this.deleteApprovalUser(this.selectedId).then(() => {
        this.dialog = false
        let response = this.getResponse
        this.snackbar = true
        this.text =
          response.status === 200
            ? 'Deleted successfully.'
            : response.data.message
        this.color = response.status === 200 ? 'success' : 'error'
      })
    },

    setUserStatus(_id, _status) {
      let status = _status === 1 ? 0 : 1
      this.blockApprovalUser({ id: _id, is_blocked: status }).then(() => {
        // do nothing
      })
    }
  },
  mounted: function() {
    this.fetchApprovalUsers()
  },
  computed: {
    ...mapGetters(['getApprovalUsers', 'getLoading', 'getResponse'])
  }
}
</script>

<style scoped>
.input-group label {
  font-size: 13px !important;
}

.custom-loader {
  animation: loader 1s infinite;
  display: flex;
}

@-moz-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}

@-webkit-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}

@-o-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}

@keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
</style><style lang="stylus" scoped>
div {
  text-align: center;
}

.progress-circular {
  margin: 1rem;
}
</style>




// WEBPACK FOOTER //
// src/components/mobile-user/ApproverDetail.vue